import gql from 'graphql-tag';

export default gql`
  mutation changeRepVisitsContactNotes($input: changeRepVisitsContactNotesInput!) {
    changeRepVisitsContactNotes(input: $input) {
      repVisitsContact {
        id,
        notes,
      }
    }
  }
`;
